'use client';

import { Box, HStack } from '@terra/ui-styled-system';
import { Text, Button, Card } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import type { AdGraphEdgeDto } from '@terra/shared-contracts-internal-network';
import { getAdGraphLinkDisplayLabel } from '@terra/shared-contracts-internal-network';

type InternalNetworkGraphEdgePanelProps = {
  edge: AdGraphEdgeDto;
  onClose: () => void;
};

export function InternalNetworkGraphEdgePanel({
  edge,
  onClose,
}: InternalNetworkGraphEdgePanelProps) {
  const t = useTranslations('internalNetwork.graph');

  return (
    <Box position="absolute" bottom={3} left={3} zIndex={5} maxW="320px">
      <Card.Root
        p={3}
        backgroundColor="bg.default"
        borderWidth="1px"
        borderColor="border.neutral.subtle"
        boxShadow="sm"
      >
        <HStack justifyContent="space-between" alignItems="flex-start" gap={3}>
          <Box flex={1}>
            <Text fontSize="xs" color="fg.muted" mb={1}>
              {t('explore.selectedRelationship')}
            </Text>
            <Text
              fontSize="sm"
              fontWeight="semibold"
              color={edge.isAbusable ? 'fg.error' : 'fg.default'}
            >
              {getAdGraphLinkDisplayLabel(edge)}
            </Text>
            <Text fontSize="xs" color="fg.subtle" mt={1} fontFamily="mono">
              {edge.relationshipType}
            </Text>
          </Box>
          <Button size="xs" variant="ghost" onClick={onClose}>
            {t('explore.clearSelection')}
          </Button>
        </HStack>
      </Card.Root>
    </Box>
  );
}
